export default {
    scale: 100000,

    fromRealToLogValue(value) {
        return Math.round(Math.log(value) * this.scale);
    },

    fromLogToRealValue(position) {
        return Math.round(Math.exp(position / this.scale));
    },
};
